var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoatCheese(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 100 600 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m475,169c0,0 -356,-2 -356,-2c0,0 -81,8 -68,145c13,137 78,119 78,119c0,0 354,1 354,1c0,0 90,-31 74,-150",
    strokeWidth: 0,
    stroke: "#000",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 10,
    ry: 130.5,
    rx: 73.5,
    cy: 300,
    cx: 482.5,
    stroke: "#000",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 169,
    x2: 487,
    y1: 169,
    x1: 120,
    strokeWidth: 10,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 431,
    x2: 487,
    y1: 431,
    x1: 120,
    strokeWidth: 10,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m124,169.00019c0,0 -77,-5.03846 -74,126.96914c3,132.0076 74,135.03068 74,135.03068",
    opacity: "NaN",
    strokeWidth: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 237,
    x2: 382,
    y1: 237,
    x1: 105,
    strokeWidth: 10,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 306,
    x2: 367,
    y1: 306,
    x1: 90,
    strokeWidth: 10,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 368,
    x2: 387,
    y1: 368,
    x1: 110,
    strokeWidth: 10,
    stroke: "#000",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoatCheese);
export default __webpack_public_path__ + "static/media/GoatCheese.622b67c189a719fcae94868369609f3f.svg";
export { ForwardRef as ReactComponent };